// /tickets szegmens layout-ja — csak auth-guard + <Outlet/>. A tényleges oldalak a gyerek-route-okban:
// tickets.index (lista) · tickets.$id (detail — a jegy teljes munkafelülete).
// KRITIKUS: a listát KÜLÖN index-route (tickets.index) adja, NEM ez a layout — így a gyerek-route-ok az
// <Outlet/>-ben renderelődnek (korábban a tickets.tsx maga volt a lista Outlet nélkül → a gyerek-route URL-je
// változott, de a komponens sosem renderelődött). A clients szegmens mintája (clients.tsx).
// (A `tickets.best-practices` gyerek-route kivezetve — a funkció megszűnt.)
import { createFileRoute, Outlet } from '@tanstack/react-router';

import { requireAuth } from '@/lib/auth';

export const Route = createFileRoute('/tickets')({
  beforeLoad: () => requireAuth(),
  component: TicketsLayout,
});

function TicketsLayout(): JSX.Element {
  return <Outlet />;
}
